import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { IInitialState } from '../../../reduxService';
import * as BeMaccaferriStoreHelper from '../../api/store/BeMaccaferriStoreHelper';
import { IMaterialResponse } from '../../api/IApiResponse';

const initialState: IInitialState<IMaterialResponse> = {
    initialState: true,
};

export const materialDetailSlice = createSlice({
    name: 'materialDetail',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchMaterialById.pending, (state, action) => {
                state.data = undefined;
                state.pending = true;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchMaterialById.fulfilled, (state, action) => {
                state.data = action.payload;
                state.pending = false;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchMaterialById.rejected, (state, action) => {
                state.data = undefined;
                state.pending = false;
                state.error = {
                    status: (action.payload as any).status,
                    data: (action.payload as any).data,
                };
                state.initialState = false;
            });
    },
});

export const fetchMaterialById = createAsyncThunk('api/Material/GetById', async (id: number, { rejectWithValue }) => {
    try {
        const response = await BeMaccaferriStoreHelper.getMaterialByIdAsync(id);
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response);
    }
});

export default materialDetailSlice.reducer;
